import { render } from "./NavigatorBar.vue?vue&type=template&id=f6a6c834"
import script from "./NavigatorBar.vue?vue&type=script&lang=js"
export * from "./NavigatorBar.vue?vue&type=script&lang=js"

import "./NavigatorBar.vue?vue&type=style&index=0&id=f6a6c834&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__